import React from "react";
import { ChevronRight } from "lucide-react";

import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";


import logo from "../images/LandingPage/logo.png";

const COLORS = {
  primary: "#0078c9",
  accent: "#9e0b22",
  navy: "#062a4f",
  dark: "#071827",
  muted: "#64748b",
};
function Footer() {
    
  const navLinks = [
    { label: "Home", href: "/" },
    { label: "Solutions", href: "#solutions" },
    { label: "Applications", href: "#apps" },
    { label: "About", href: "#about" },
    { label: "Contact", href: "#contact" },
  ];

  const services = [
    { title: "AI & Modeling Intelligence" },
    { title: "Risk & Reliability Solutions" },
    { title: "Industrial Optimization" },
    { title: "Dynamic Simulation" },
    { title: "Predictive Analytics" },
  ];

  return (
    <>
    <style>{styles}</style>
    <footer className="site-footer">
      <div className="footer-grid">
        <div>
          <img
            src={logo}
            alt="Optimizegs"
            className="footer-logo"
          />

          <p>85 Great Portland st. First Floor W1W7LT London, United Kingdom</p>
          <p>Abu Dhabi, Khalifa Bin Zayed the 1st Street.WTC Building </p>

          <p>
            <strong>Email:</strong> business@optimizegs.com
          </p>
        </div>

        <div>
          <h4>Useful Links</h4>

          {navLinks.map((link) => (
            <a key={link.href} href={link.href}>
              <ChevronRight size={14} />
              {link.label}
            </a>
          ))}
        </div>

        <div>
          <h4>Our Services</h4>

          {services.map((service) => (
            <a key={service.title} href="#services">
              <ChevronRight size={14} />
              {service.title}
            </a>
          ))}
        </div>

        <div>
          <h4>Follow Us</h4>

          <div className="social-links">
           
            <a
              href="https://www.linkedin.com/company/optimize-hydrocarbon-energey"
               
              rel="noreferrer"
            >
              <LinkedInIcon />
            </a>
          </div>
        </div>
      </div>

      <div className="copyright">
        © Copyright <strong>Optimizegs</strong>. All Rights Reserved
      </div>
    </footer>
    </>
  );
}

export default Footer;


const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

  .modern-company-page {
    --primary: ${COLORS.primary};
    --accent: ${COLORS.accent};
    --navy: ${COLORS.navy};
    --dark: ${COLORS.dark};
    --muted: ${COLORS.muted};
    font-family: 'Inter', sans-serif;
    color: var(--dark);
    background: #ffffff;
    overflow-x: hidden;
  }

  .site-header {
    position: fixed;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    width: min(1180px, calc(100% - 32px));
    min-height: 74px;
    padding: 10px 14px 10px 22px;
    border-radius: 24px;
    background: #fff;
    backdrop-filter: blur(18px);
    box-shadow: 0 18px 50px rgba(8, 37, 68, 0.14);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1000;
  }

  .brand img { width: 150px; height: 58px; object-fit: contain; display: block; }

  .nav-links { display: flex; gap: 6px; align-items: center; }
  .nav-links a {
    text-decoration: none;
    color: #17324d;
    font-size: 14px;
    font-weight: 700;
    padding: 10px 12px;
    border-radius: 999px;
    transition: 0.25s ease;
  }
  .nav-links a:hover { background: rgba(0,120,201,0.10); color: var(--primary); }

  .header-actions { display: flex; align-items: center; gap: 10px; }
  .menu-btn {
    display: none;
    border: 0;
    border-radius: 14px;
    width: 44px;
    height: 44px;
    background: rgba(0,120,201,0.10);
    color: var(--primary);
    cursor: pointer;
  }

  .primary-btn, .secondary-btn, .outline-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border-radius: 999px;
    font-size: 14px;
    font-weight: 800;
    text-decoration: none;
    transition: 0.25s ease;
  }

  .primary-btn {
    color: white;
    background: linear-gradient(135deg, var(--primary), #005da0);
    padding: 14px 22px;
    box-shadow: 0 14px 30px rgba(0,120,201,0.30);
  }
  .primary-btn:hover { transform: translateY(-2px); box-shadow: 0 18px 40px rgba(0,120,201,0.38); }
  .primary-btn.small { padding: 12px 18px; }

  .secondary-btn, .outline-btn {
    color: var(--primary);
    border: 1px solid rgba(0,120,201,0.28);
    background: white;
    padding: 13px 20px;
  }
  .secondary-btn:hover, .outline-btn:hover { border-color: var(--accent); color: var(--accent); transform: translateY(-2px); }

  .hero-section {
    min-height: 100vh;
    padding: 150px 24px 90px;
    background:
      radial-gradient(circle at 12% 18%, rgba(0,120,201,0.18), transparent 34%),
      radial-gradient(circle at 90% 24%, rgba(158,11,34,0.14), transparent 28%),
      linear-gradient(135deg, #061d34 0%, #082f56 52%, #04121f 100%);
    position: relative;
    overflow: hidden;
  }

  .hero-content {
    width: min(1180px, 100%);
    margin: auto;
    display: grid;
    grid-template-columns: 1.02fr 0.98fr;
    gap: 56px;
    align-items: center;
    position: relative;
    z-index: 2;
  }

  .pill {
    width: fit-content;
    color: white;
    background: rgba(255,255,255,0.12);
    border: 1px solid rgba(255,255,255,0.18);
    padding: 9px 14px;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 800;
    margin-bottom: 22px;
  }

  .hero-copy h1 {
    color: white;
    font-size: clamp(42px, 6vw, 76px);
    line-height: 0.96;
    letter-spacing: -3px;
    margin: 0 0 22px;
  }
  .hero-copy p {
    color: rgba(255,255,255,0.78);
    font-size: 18px;
    line-height: 1.8;
    max-width: 620px;
    margin: 0 0 32px;
  }
  .hero-buttons { display: flex; gap: 14px; flex-wrap: wrap; }

  .hero-visual { position: relative; }
  .hero-visual img {
    width: 650px;
    min-height: 430px;
    object-fit: cover;
    border-radius: 34px;
    border: 4px solid rgba(158,11,34,0.75);
    box-shadow: 0 32px 90px rgba(0,0,0,0.38);
  }
  .hero-card {
    position: absolute;
    z-index: 3;
    background: rgba(255,255,255,0.92);
    border: 1px solid rgba(255,255,255,0.35);
    box-shadow: 0 18px 48px rgba(0,0,0,0.20);
    border-radius: 20px;
    padding: 16px 18px;
    min-width: 190px;
  }
  .hero-card span { color: var(--muted); font-size: 12px; font-weight: 700; display: block; margin-bottom: 5px; }
  .hero-card strong { color: var(--navy); font-size: 17px; }
  .top-card {
  top: -42px;
  left: -80px;
}

.bottom-card {
  right: -70px;
  bottom: -35px;
}

  .products-section, .section-pad { padding: 86px 24px; }
  .tinted-section { background: linear-gradient(180deg, #f7fbff, #ffffff); }

  .section-title { text-align: center; width: min(780px, 100%); margin: 0 auto 44px; }
  .section-title span {
    color: var(--accent);
    background: rgba(158,11,34,0.08);
    padding: 7px 13px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  .section-title h2 {
    font-size: clamp(30px, 4vw, 48px);
    color: var(--navy);
    letter-spacing: -1.6px;
    margin: 14px 0 12px;
  }
  .section-title p { color: var(--muted); line-height: 1.8; margin: 0; }

  .logo-marquee {
    width: min(1180px, 100%);
    margin: auto;
    overflow: hidden;
    mask-image: linear-gradient(to right, transparent, black 12%, black 88%, transparent);
  }
  .logo-track { display: flex; gap: 22px; width: max-content; animation: marquee 24s linear infinite; }
  .logo-card {
    width: 155px;
    height: 92px;
    display: grid;
    place-items: center;
    background: white;
    border-radius: 22px;
    border: 1px solid rgba(0,120,201,0.10);
    box-shadow: 0 12px 34px rgba(8,37,68,0.08);
  }
  .logo-card img { max-width: 112px; max-height: 68px; object-fit: contain; filter: saturate(1.05); }
  @keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }

  .about-grid, .cards-grid, .contact-card, .footer-grid {
    width: min(1180px, 100%);
    margin: auto;
  }
    
  .about-grid { display: grid; grid-template-columns: 0.95fr 1.05fr; gap: 24px; }
  .about-panel {
    background: white;
    border: 1px solid rgba(0,120,201,0.12);
    border-radius: 30px;
    padding: 34px;
    box-shadow: 0 18px 48px rgba(8,37,68,0.08);
  }
    .about-panel h3 {
    color: white;
  }
  .highlight-panel { background: linear-gradient(135deg, var(--primary), #064b7f); color: white; }
  .highlight-panel h3 { font-size: 30px; line-height: 1.22; margin: 0 0 18px; }
  .highlight-panel p { color: rgba(255,255,255,0.82); }
  .about-panel p { line-height: 1.85; color: #fff; }

  .check-list { list-style: none; padding: 0; margin: 0 0 22px; display: grid; gap: 14px; }
  .check-list li { display: flex; align-items: flex-start; gap: 10px; color: #17324d; font-weight: 700; line-height: 1.55; }
  .check-list svg { color: var(--accent); min-width: 20px; margin-top: 2px; }
  .text-link, .post-body a, .card-link {
    color: var(--primary);
    text-decoration: none;
    font-weight: 900;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .cards-grid { display: grid; gap: 24px; }
  .cards-grid.three { grid-template-columns: repeat(3, 1fr); }
  .cards-grid.four { grid-template-columns: repeat(4, 1fr); }

  .solution-card, .service-card, .post-card {
    background: white;
    border: 1px solid rgba(0,120,201,0.12);
    border-radius: 30px;
    overflow: hidden;
    box-shadow: 0 18px 48px rgba(8,37,68,0.08);
    transition: 0.25s ease;
  }
  .solution-card { text-decoration: none; color: inherit; }
  .solution-card:hover, .service-card:hover, .post-card:hover { transform: translateY(-8px); box-shadow: 0 26px 70px rgba(8,37,68,0.14); }
  .solution-image, .post-image { position: relative; height: 220px; overflow: hidden; }
  .solution-image img, .post-image img { width: 100%; height: 100%; object-fit: cover; transition: 0.35s ease; }
  .solution-card:hover .solution-image img, .post-card:hover .post-image img { transform: scale(1.06); }
  .solution-image span, .post-image span {
    position: absolute;
    right: 16px;
    top: 16px;
    background: var(--accent);
    color: white;
    border-radius: 999px;
    padding: 8px 12px;
    font-weight: 900;
    font-size: 13px;
  }
  .solution-body, .post-body { padding: 24px; }
  .solution-logo { width: 88px; height: 58px; object-fit: contain; margin-bottom: 10px; }
  .solution-body h3, .service-card h3, .post-body h3 { color: var(--navy); font-size: 22px; margin: 0 0 12px; }
  .solution-body p, .service-card p, .post-body p { color: var(--muted); line-height: 1.75; margin: 0 0 18px; }

  .service-card { padding: 30px; }
  .service-icon {
    width: 62px;
    height: 62px;
    border-radius: 20px;
    display: grid;
    place-items: center;
    color: white;
    background: linear-gradient(135deg, var(--primary), var(--accent));
    margin-bottom: 22px;
  }

  .section-action { width: min(1180px, 100%); margin: 28px auto 0; display: flex; justify-content: flex-end; }

  .contact-card {
    display: grid;
    grid-template-columns: 1.1fr 0.9fr;
    gap: 30px;
    border-radius: 34px;
    padding: 38px;
    color: white;
    background:
      radial-gradient(circle at 90% 10%, rgba(158,11,34,0.5), transparent 32%),
      linear-gradient(135deg, #072746, #03111e);
    box-shadow: 0 24px 70px rgba(8,37,68,0.24);
  }
  .contact-card h3 { font-size: 30px; margin: 0 0 14px; color:#fff}
  .contact-card p { color: #fff; line-height: 1.8; margin: 0; }
  .contact-list { display: grid; gap: 18px; align-content: center; }
  .contact-list div { display: flex; gap: 12px; align-items: flex-start; color: #fff; line-height: 1.55; }
  .contact-list svg { color: #ffbac5; min-width: 22px; }
  .contact-list a { color: white; text-decoration: none; font-weight: 800; }

  .site-footer {
    padding: 70px 24px 24px;
 background:
      radial-gradient(circle at 12% 18%, rgba(0,120,201,0.18), transparent 34%),
      radial-gradient(circle at 90% 24%, rgba(158,11,34,0.14), transparent 28%),
      linear-gradient(135deg, #061d34 0%, #082f56 52%, #04121f 100%);    color: #fff;
  }
  .footer-grid { display: grid; grid-template-columns: 1.4fr 0.8fr 1fr 0.8fr; gap: 38px; }
  .footer-logo { width: 210px; height: 70px; object-fit: contain; background: white; border-radius: 18px; padding: 8px 12px; margin-bottom: 18px; }
  .site-footer h4 { color: white; margin: 0 0 18px; }
  .site-footer a { display: flex; align-items: center; gap: 6px; color: rgba(255,255,255,0.72); text-decoration: none; margin-bottom: 12px; transition: 0.2s; }
  .site-footer a:hover { color: white; }
  .social-links { display: flex; gap: 10px; }
  .social-links a {
    width: 42px;
    height: 42px;
    border-radius: 999px;
    display: grid;
    place-items: center;
    background: rgba(255,255,255,0.08);
    color: white;
  }
  .copyright { width: min(1180px, 100%); margin: 40px auto 0; padding-top: 22px; border-top: 1px solid rgba(255,255,255,0.10); text-align: center; font-size: 14px; }

  @media (max-width: 980px) {
    .site-header { top: 10px; width: calc(100% - 20px); }
    .menu-btn { display: grid; place-items: center; }
    .nav-links {
      position: absolute;
      top: 86px;
      left: 0;
      right: 0;
      display: none;
      flex-direction: column;
      align-items: stretch;
      padding: 16px;
      border-radius: 22px;
      background: white;
      box-shadow: 0 20px 50px rgba(8,37,68,0.16);
    }
    .nav-links.open { display: flex; }
    .hero-content, .about-grid, .contact-card { grid-template-columns: 1fr; }
    .hero-section { padding-top: 130px; }
    .top-card { left: 14px; }
    .bottom-card { right: 14px; }
    .cards-grid.three, .cards-grid.four, .footer-grid { grid-template-columns: repeat(2, 1fr); }
  }

  @media (max-width: 640px) {
    .primary-btn.small { display: none; }
    .brand img { width: 128px; }
    .hero-copy h1 { letter-spacing: -1.5px; }
    .hero-visual img { min-height: 320px; border-radius: 24px; }
    .hero-card { position: static; margin-top: 12px; }
    .cards-grid.three, .cards-grid.four, .footer-grid { grid-template-columns: 1fr; }
    .about-panel, .contact-card { padding: 26px; border-radius: 24px; }
    .section-action { justify-content: stretch; }
    .section-action .outline-btn { width: 100%; }
  }
`;